import { ADMIN, ifyouApi } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';

export const platformSoundList = async () => {
  try {
    const res = await ifyouApi.post(`${ADMIN}/-1/platform-sound-list`, {
      sound_type: 'se',
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const platformSoundRegister = async (formData) => {
  try {
    const res = await ifyouApi.post(
      `${ADMIN}/-1/platform-sound-insert`,
      formData,
      {
        header: { 'Content-Type': 'multipart/form-data' },
      },
    );
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
export const platformSoundUpdate = async (formData) => {
  try {
    const res = await ifyouApi.post(
      `${ADMIN}/-1/platform-sound-insert`,
      formData,
      {
        header: { 'Content-Type': 'multipart/form-data' },
      },
    );
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
export const platformSoundZipUpload = async (formData) => {
  try {
    const res = await ifyouApi.post(
      `${ADMIN}/-1/platform-sound-insert`,
      formData,
      {
        header: { 'Content-Type': 'multipart/form-data' },
      },
    );
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
export const platformSoundDelete = async (soundId) => {
  try {
    const res = await ifyouApi.post(`${ADMIN}/-1/platform-sound-delete`, {
      sound_id: soundId,
      sound_type: 'se',
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
